import { render, staticRenderFns } from "./TrashCanOutline.vue?vue&type=template&id=16ea0390"
import script from "./TrashCanOutline.vue?vue&type=script&lang=js"
export * from "./TrashCanOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports